import Marquee from "react-fast-marquee";

const WORDS = ["HERO SPLENDOR", "XTREME 160R", "VIDA ELECTRIC", "XPULSE 210", "XOOM 125", "KARIZMA XMR", "MAVRICK 440", "DESTINI 125"];

export const Ribbon = () => (
  <div className="border-y border-white/10 bg-red-600 py-4 md:py-5">
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="font-heading text-2xl md:text-4xl font-bold uppercase tracking-tight text-white/95 mx-8 flex items-center gap-8">
          {w}
          <span className="text-black/40">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
